module.exports = __webpack_public_path__ + "img/mine_6_active.a0bd13d8.png";